module.exports = __webpack_public_path__ + "static/media/d12ru.c3f7673b.pdf";